<template>
    <div class="body">
        <div class="box">
            <div class="tip">请输入您的孩子的证件号码获取缴费账单：</div>
            <div class="card">
                <span class="text">二代身份证号码:</span>
                <el-input v-model="query.idCard" placeholder="请输入身份证" clearable></el-input>
            </div>
            <div class="tip1">
                <i class="el-icon-info"></i> 如果身份证号码不存在，请联系孩子所在学校实名登记
            </div>
        </div>

        <div class="btns">
            <el-button type="success" class="btn" @click="getList()">查找账单</el-button>
        </div>
    </div>
</template>

<script>
    import {Notify} from 'vant';

    export default {
        name: "billInquiry",
        data(){
            return{
                query: {
                    idCard:''
                },
                list:[],
                appId:'', // wx2b735862ca820115
            }
        },
        created() {
            this.appId=this.$route.query.appId
        },
        methods:{
            getList() {
                let _this = this
                let url = '/zuhu1/api-dashboard/studentBill/search_prepare'
                let query = this.query
                if(!query.idCard){
                    this.$message({
                        type: 'warning',
                        message: '请输入身份证号'
                    })
                    return
                }
                this.$api.post(url, query, function (result) {
                    let datas = result.data.data || []
                    if(datas.length>0){
                        localStorage.setItem('idCard', _this.query.idCard)
                        localStorage.setItem('appId', _this.appId)

                        if(_this.appId){
                            const appId = _this.appId; // 你的微信公众号AppID
                            const redirectUri = encodeURIComponent('https://wxztc.com.cn/#/studentBill'); // 替换为你的回调域名，必须在微信公众号后台配置
                            const state = 'custom_state'; // 可选参数，用于保持状态，防止CSRF攻击
                            const scope = 'snsapi_base'; // 授权作用域，snsapi_base（静默授权）或 snsapi_userinfo（弹窗授权）
                            const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
                            window.location.href = authUrl;
                        }else{
                            _this.$router.push({name: 'studentBill'})
                        }


                        return
                    }
                    if(result.data.message=='no bills'){
                        _this.$message({
                            type: 'warning',
                            message: '未找到账单'
                        })
                    }else if(result.data.message=='no students'){
                        _this.$message({
                            type: 'warning',
                            message: '未找到学生'
                        })
                    }else{
                        _this.$message({
                            type: 'warning',
                            message: result.data.message
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .body{
        background: white;
        width: 100%;
        height: 100%;
    }
    .box{
        padding: 20px;
        box-sizing: border-box;
    }
    .tip{
        font-size: 14px;
        color: #BBBBBB;
    }
    .card{
        display: flex;
        font-size: 14px;
        padding: 10px 0;
    }
    .text{
        width: 150px;
        display: flex;
        align-items: center;
    }
    .tip1{
        color: #101010;
        font-size: 12px;
        padding: 10px 0;
    }
    .btns{
        text-align: center;
        margin-top: 100px;
    }
    .btn{
        width: 80%;
    }
</style>
